const crypto = require('pbkdf2');
const textEncoding = require('text-encoding');
const TextDecoder = textEncoding.TextDecoder;

export class Crypto {
	static numberOfIterations: number = 50000;

	/**
	 * This function will be used for user authentication to hash the login password. Return type is base64String
	 * @param plaintext is the text you want to hash.
	 * @param salt type needs to be as base64string you could use "hello".toString('base64') if needed.
	 */
	static HashWithBase64Salt(plaintext: string, saltAsBase64String: string): string {
		const hashedText = crypto.pbkdf2Sync(
			plaintext,
			this.base64ToBuffer(saltAsBase64String),
			this.numberOfIterations,
			32
		);
		var result = new Buffer(hashedText).toString('base64');
		console.log(result);
		return result;
	}

	/**
	 * This function is used for hashing the multistring which is saved in SignMessRequests table. Return type is base64String
	 * @param plaintext is the text you want to hash.
	 * @param salt just a salt as a string
	 */
	static async HashWithSalt(plaintext: string, salt: string): Promise<string> {
		return new Promise<string>(function (resolve, reject) {
			crypto.pbkdf2(plaintext, salt, 50000, 32, function (err, hash) {
				// console.log("this is res", hash)
				var result = new Buffer(hash).toString('base64');
				resolve(result);
			});
		});

		// const hashedText = "dummyhash"
		// const hashedText = crypto.pbkdf2Sync(plaintext, salt, this.numberOfIterations, 32);
		// var result = new Buffer(hashedText).toString('base64')
		// console.log("",hashedText);
		// return result;
	}

	static base64ToBuffer(base64) {
		var binary_string = window.atob(base64);
		var len = binary_string.length;
		var bytes = new Uint8Array(len);
		for (var i = 0; i < len; i++) {
			bytes[i] = binary_string.charCodeAt(i);
		}
		return bytes;
	}
	// This actually isn't needed right now
	static GenerateSalt() {
		return crypto.randomBytes(32);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/libraries/Crypto.ts